import React from "react";
import { Link } from "react-router-dom";
import classes from "./BreadCrumb.module.css";

export default function BreadCrumb({ currentPage }) {
  return (
    <section className={classes.breadcrumbWrapper}>
      <div className={classes.breadcrumbNav}>
        <Link to="/" className={classes.breadcrumbHome}>
          Home
        </Link>
        <span className={classes.breadcrumbSeparator}>›</span>
        <span className={classes.breadcrumbCurrent}>{currentPage}</span>
      </div>

      <h1 className={classes.breadcrumbTitle}>{currentPage}</h1>
    </section>
  );
}
